import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes safely (later wins on conflicts). */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
